import { render, staticRenderFns } from "./sitc-encode-company.vue?vue&type=template&id=a69d7064&scoped=true&"
import script from "./sitc-encode-company.vue?vue&type=script&lang=js&"
export * from "./sitc-encode-company.vue?vue&type=script&lang=js&"
import style0 from "./sitc-encode-company.vue?vue&type=style&index=0&id=a69d7064&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a69d7064",
  null
  
)

export default component.exports